// Add keys to this enum which needs to be cleared when user emulation occurs
export enum CacheKeys {
  WorkPackageDrawerValues = 'drawerValues',
  PlanningWorkPackageDrawerValues = 'planningWorkPackageDrawerValues',
  WorkPackageListCursor = 'wpListCursor',
  BlockDrawerValues = 'blockDrawerValues',
  PlanningSelectedForeman = 'planningSelectedForeman',
  PlanningSelectedGeneralForeman = 'planningSelectedGeneralForeman',
  PlanningSelectedSuperintendent = 'planningSelectedSuperintendent',
  BacklogFilter = 'BacklogFilter',
  WorkListDrawerValues = 'workListDrawerValues',
  WorkListSelectionStateValues = 'workListSelectionStateValues',
  PendingApprovalListSelectedState = 'pendingApprovalListSelectedState',
  PendingApprovalListDrawerValues = 'pendingApprovalListDrawerValues',
  PlanningProgressSelectedWeek = 'planningProgressSelectedWeek',
  DashboardSelectedUser = 'dashboardSelectedUser',
  PlanningSelectedTab = 'planningSelectedTab',
  UserListDrawerValues = 'UserListDrawerValues',
  WeldDrawerValues = 'WeldDrawerValues',
  WeldListCursor = 'WeldListCursor',
  SelectedRodRoom = 'SelectedRodRoom',
  RodRequestListDrawerValues = 'RodRequestListDrawerValues',
  WeldDashboardDrawerValues = 'WeldDashboardDrawerValues',
}

export const EMULATED_USER_ID = 'emulate-user-id';
export const USER_PROJECT_ID = 'user-project-id';
export const DEVICE_TYPE = 'device-type';
export const HEADER_USER_ID: string = 'x-bps-user-id';
export const HEADER_DEVICE_ID: string = 'x-bps-device-id';
export const HEADER_APP_TYPE_ID: string = 'app-type-id';
